import { Component, OnInit, Input } from '@angular/core';
import {CommonService} from "src/service/common.service";
@Component({
  selector: 'app-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss']
})
export class NoDataComponent implements OnInit {
  @Input() NoDataInfo:any;
  constructor(
    private com:CommonService
  ) { }

  ngOnInit() {
  }
  EventClick(){
    this.com.goBack();
  }
}
